import React, { Component } from "reactn";
import { DialogTitle, DialogActions, Button } from "@material-ui/core";

import { BlueButton } from "js/react/components/UiComponents.js";
import DialogContent from "./DialogContent";
import BeautifulDialog from "./BeautifulDialog";

export default class MessageDialog extends Component {
    render() {
        const {
            title,
            message,
            buttonText,
            acceptOnClose,
            onClick,
            onBackdropClick,
            closeDialog,
            buttonOptions = {}
        } = this.props;

        return (
            <BeautifulDialog
                closeDialog={() => {
                    if (acceptOnClose) {
                        onClick && onClick();
                    }
                    closeDialog();
                }}
                onBackdropClick={onBackdropClick ? onBackdropClick : () => { }}
            >
                <DialogTitle>{title}</DialogTitle>
                <DialogContent>{message}</DialogContent>
                <DialogActions>
                    {buttonOptions.color === "blue" ? (
                        <BlueButton
                            onClick={() => {
                                closeDialog();
                                onClick && onClick();
                            }}
                        >
                            {buttonText || "OK"}
                        </BlueButton>
                    ) : (
                        <Button
                            onClick={() => {
                                onClick && onClick();
                                closeDialog();
                            }}
                        >
                            {buttonText || "OK"}
                        </Button>
                    )}
                </DialogActions>
            </BeautifulDialog>
        );
    }
}
